import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "operations-kpis" }
const _hoisted_2 = { class: "row g-2" }
const _hoisted_3 = { class: "col-sm-6 col-lg-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_5 = {
  key: 1,
  class: "skeleton skeleton-badges"
}
const _hoisted_6 = {
  key: 2,
  class: "top-utilization-list"
}
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_8 = { class: "room-name" }
const _hoisted_9 = { class: "room-count" }
const _hoisted_10 = { class: "progress kpi-progress" }
const _hoisted_11 = {
  key: 3,
  class: "text-muted small"
}
const _hoisted_12 = { class: "col-sm-6 col-lg-3" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = {
  key: 1,
  class: "skeleton skeleton-value"
}
const _hoisted_15 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_16 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_17 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_18 = { class: "col-sm-6 col-lg-3" }
const _hoisted_19 = {
  key: 1,
  class: "skeleton skeleton-value"
}
const _hoisted_20 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_21 = { class: "col-sm-6 col-lg-3" }
const _hoisted_22 = {
  key: 1,
  class: "skeleton skeleton-value"
}
const _hoisted_23 = {
  key: 3,
  class: "text-muted"
}

import { computed } from 'vue';
import KpiCard from './KpiCard.vue';

const TOP_ROOMS_SHOWN = 2;


export default {
  __name: 'OperationsKpis',
  props: {
  analytics: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: [Object, Error, String],
    default: null,
  },
},
  setup(__props) {

const props = __props;

const errorMessage = computed(() => {
  if (!props.error) return '';
  if (typeof props.error === 'string') return props.error;
  return props.error.message || 'Fehler beim Laden der Daten';
});

const topRooms = computed(() => {
  const top = Array.isArray(props.analytics?.topRooms)
    ? props.analytics.topRooms.slice(0, TOP_ROOMS_SHOWN)
    : [];

  if (!top.length) {
    return [];
  }

  const maxCount = top[0]?.count || 1;
  return top.map((room) => ({
    ...room,
    ratio: Math.round((room.count / maxCount) * 100),
  }));
});

const cancellations = computed(() => props.analytics?.cancellations || null);
const averages = computed(() => props.analytics?.averages || null);

const formatDecimal = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return '0.0';
  return num.toFixed(1);
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Top Rooms by Booking Count "),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(KpiCard, {
          title: "Top Räume",
          icon: "fas fa-fire",
          "icon-color-class": "text-danger",
          compact: "",
          hint: "Nach Anzahl Buchungen"
        }, {
          default: _withCtx(() => [
            (__props.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1 /* TEXT */))
              : (__props.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : (topRooms.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topRooms.value, (room, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: room.id,
                          class: "top-utilization-item"
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, "#" + _toDisplayString(index + 1) + " " + _toDisplayString(room.label), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(room.count), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", {
                              class: "progress-bar",
                              style: _normalizeStyle({ width: `${room.ratio}%` })
                            }, null, 4 /* STYLE */)
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, " Keine Daten verfügbar "))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createCommentVNode(" Cancellations "),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(KpiCard, {
          title: "Stornorate",
          icon: "fas fa-ban",
          "icon-color-class": "text-danger"
        }, {
          footer: _withCtx(() => [
            (cancellations.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(cancellations.value.count) + " Buchungen storniert ", 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_17, "—"))
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_13, [
              (__props.error)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" — ")
                  ], 64 /* STABLE_FRAGMENT */))
                : (__props.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                  : (cancellations.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(formatDecimal(cancellations.value.rate)) + "% ", 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createCommentVNode(" Average Booking Duration "),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(KpiCard, {
          title: "Ø Buchungsdauer",
          icon: "fas fa-clock",
          "icon-color-class": "text-info",
          hint: "Durchschnittliche Dauer"
        }, {
          default: _withCtx(() => [
            (__props.error)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" — ")
                ], 64 /* STABLE_FRAGMENT */))
              : (__props.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                : (averages.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(formatDecimal(averages.value.bookingDurationMinutes)) + " ", 1 /* TEXT */),
                      _cache[0] || (_cache[0] = _createElementVNode("small", { class: "fs-6 fw-normal text-muted" }, "Min.", -1 /* CACHED */))
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, "—"))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createCommentVNode(" Average Bookings Per Active Day "),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(KpiCard, {
          title: "Ø Buchungen / Tag",
          icon: "fas fa-calendar-check",
          "icon-color-class": "text-success",
          hint: "Nur aktive Buchungstage"
        }, {
          default: _withCtx(() => [
            (__props.error)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" — ")
                ], 64 /* STABLE_FRAGMENT */))
              : (__props.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                : (averages.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(formatDecimal(averages.value.bookingsPerActiveDay)), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, "—"))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}
}

}